import { Config, Context, Data, Effect, Layer, pipe, Schema } from "effect";
import { decodeBase64String } from "effect/Encoding";
import sodium from "libsodium-wrappers";
import { SealedSecretValueStructFromString } from "../SealingSecretsSchema";
//
// Can really only fail if libsodium has an error
//
export class SecretSealerError extends Data.TaggedError("@open-revenue/utils/SecretSealer/SecretSealerError") {
    error;
    constructor(error){
        super(), this.error = error;
    }
}
const make = (config)=>Effect.gen(function*() {
        const { keyId, publicKey } = config;
        const sealSecretValue = (value)=>Effect.gen(function*() {
                yield* Effect.promise(()=>sodium.ready);
                try {
                    const encrypted = sodium.crypto_box_seal(value, sodium.from_base64(publicKey));
                    const encodedSecret = sodium.to_base64(encrypted);
                    const encoded = yield* Schema.encode(SealedSecretValueStructFromString)({
                        keyId,
                        encryptedSecretValue: encodedSecret
                    });
                    return encoded;
                } catch (error) {
                    return yield* Effect.fail(new SecretSealerError(error));
                }
            });
        return {
            sealSecretValue
        };
    });
const makeDeferred = ({ getPublicKey, preload })=>Effect.gen(function*() {
        const cachedMake = yield* Effect.cached(getPublicKey.pipe(Effect.flatMap(make)));
        if (preload) {
            yield* Effect.runFork(cachedMake);
        }
        const sealSecretValue = (value)=>cachedMake.pipe(Effect.flatMap((srv)=>srv.sealSecretValue(value)));
        return {
            sealSecretValue
        };
    });
export class SecretSealerService extends Context.Tag("@open-revenue/utils/SecretSealer/SecretSealerService")() {
    static defaultEncoded = pipe(Config.unwrap(Config.string("SECRET_SEALER_PUBLIC_KEY")), Effect.flatMap((str)=>decodeBase64String(str).pipe(Effect.tap((decoded)=>Effect.log(`decoded: ${decoded}`)), Effect.map((decoded)=>JSON.parse(decoded)))), Effect.flatMap(make), Layer.effect(this));
    static layerDeferred = ({ getPublicKey, preload })=>pipe(makeDeferred({
            getPublicKey,
            preload
        }), Layer.effect(this));
    static layer = (config)=>pipe(make(config), Layer.effect(this));
    static layerEncoded = (config)=>pipe(decodeBase64String(config.encodedSealingKey).pipe(Effect.map((decoded)=>JSON.parse(decoded))), Effect.flatMap(make), Layer.effect(this));
    static layerConfig = (config)=>pipe(Config.unwrap(config), Effect.flatMap(make), Layer.effect(this));
    static layerConfigEncoded = (config)=>pipe(Config.unwrap(config), Effect.flatMap((str)=>decodeBase64String(str).pipe(Effect.map((decoded)=>JSON.parse(decoded)))), Effect.flatMap(make), Layer.effect(this));
    static make = make;
}
